module.exports = __webpack_public_path__ + "assets/img/map1.f7826e1a.jpg";